import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as MicrophoneIcon } from "src/modules/lullaby/icons/microphone-outlined.svg";
import { ReactComponent as MusicIcon } from "src/modules/lullaby/icons/music-outlined.svg";

export default function LullabyMenu({
  isOpen,
  onClose,
  anchorEl,
  openEditor,
  openLibrary,
  onOpen
}) {
  const { t } = useTranslation();
  return (
    <Menu
      elevationLevel={2}
      onOpen={onOpen}
      isOpen={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      py="8px"
    >
      <MenuItem onClick={openEditor}>
        <SvgContainer
          size="20px"
          fill="primary"
          mr="16px"
          icon={MicrophoneIcon}
        />
        <MenuItemText>{t("buttons.record")}</MenuItemText>
      </MenuItem>
      <MenuItem onClick={openLibrary}>
        <SvgContainer size="20px" fill="primary" mr="16px" icon={MusicIcon} />
        <MenuItemText>{t("lullaby.libraryHeader")}</MenuItemText>
      </MenuItem>
    </Menu>
  );
}
